import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=783dff1b&scoped=true&"
import script from "./page-title.vue?vue&type=script&lang=js&"
export * from "./page-title.vue?vue&type=script&lang=js&"
import style0 from "./page-title.vue?vue&type=style&index=0&id=783dff1b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783dff1b",
  null
  
)

export default component.exports